/**
 * PviInsuranceResourceService
 * API service for interacting with PVI insurance-related endpoints.
 * Auto-generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Observable } from 'rxjs';

import { Configuration } from '../configuration';
import { CustomHttpUrlEncodingCodec } from '../encoder';
import { OtaResultOfPviInsurancePolicyDTO } from '../model/otaResultOfPviInsurancePolicyDTO';
import { PVIIssueOrderRequest } from '../model/pVIIssueOrderRequest';
import { PVIOrderRequest } from '../model/pVIOrderRequest';
import { BASE_PATH3 } from '../variables';

@Injectable()
export class PviInsuranceResourceService {
  protected basePath = 'https://10.7.71.20:7883';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH3) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * Creates a new PVI insurance order.
   * @param req PVI order request
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createOrderUsingPOST(
    req: PVIOrderRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<OtaResultOfPviInsurancePolicyDTO>;
  public createOrderUsingPOST(
    req: PVIOrderRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<OtaResultOfPviInsurancePolicyDTO>>;
  public createOrderUsingPOST(
    req: PVIOrderRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<OtaResultOfPviInsurancePolicyDTO>>;
  public createOrderUsingPOST(
    req: PVIOrderRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (req === null || req === undefined) {
      throw new Error(
        'Required parameter req was null or undefined when calling createOrderUsingPOST.'
      );
    }

    let headers = this.defaultHeaders;
    const httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(
      httpHeaderAccepts
    );
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected = this.configuration.selectHeaderContentType(
      consumes
    );
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<OtaResultOfPviInsurancePolicyDTO>(
      `${this.basePath}/api/inventory/pvi/order/create`,
      req,
      {
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress
      }
    );
  }

  /**
   * Issues a PVI insurance order.
   * @param req PVI issue order request
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public issueOrderUsingPOST(
    req: PVIIssueOrderRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<OtaResultOfPviInsurancePolicyDTO>;
  public issueOrderUsingPOST(
    req: PVIIssueOrderRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<OtaResultOfPviInsurancePolicyDTO>>;
  public issueOrderUsingPOST(
    req: PVIIssueOrderRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<OtaResultOfPviInsurancePolicyDTO>>;
  public issueOrderUsingPOST(
    req: PVIIssueOrderRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (req === null || req === undefined) {
      throw new Error(
        'Required parameter req was null or undefined when calling issueOrderUsingPOST.'
      );
    }

    let headers = this.defaultHeaders;
    const httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(
      httpHeaderAccepts
    );
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected = this.configuration.selectHeaderContentType(
      consumes
    );
    if (httpContentTypeSelected !== undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<OtaResultOfPviInsurancePolicyDTO>(
      `${this.basePath}/api/inventory/pvi/order/issue`,
      req,
      {
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress
      }
    );
  }

  /**
   * Processes a PVI insurance order.
   * @param cardId Card ID
   * @param cpId CP ID
   * @param policyNumber Policy number
   * @param requestId Request ID
   * @param serialNumber Serial number
   * @param sign Signature
   * @param url URL
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public processPVIOrderUsingPOST(
    cardId?: string,
    cpId?: string,
    policyNumber?: string,
    requestId?: string,
    serialNumber?: string,
    sign?: string,
    url?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<OtaResultOfPviInsurancePolicyDTO>;
  public processPVIOrderUsingPOST(
    cardId?: string,
    cpId?: string,
    policyNumber?: string,
    requestId?: string,
    serialNumber?: string,
    sign?: string,
    url?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<OtaResultOfPviInsurancePolicyDTO>>;
  public processPVIOrderUsingPOST(
    cardId?: string,
    cpId?: string,
    policyNumber?: string,
    requestId?: string,
    serialNumber?: string,
    sign?: string,
    url?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<OtaResultOfPviInsurancePolicyDTO>>;
  public processPVIOrderUsingPOST(
    cardId?: string,
    cpId?: string,
    policyNumber?: string,
    requestId?: string,
    serialNumber?: string,
    sign?: string,
    url?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec()
    });
    if (cardId !== undefined && cardId !== null) {
      queryParameters = queryParameters.set('cardId', <any>cardId);
    }
    if (cpId !== undefined && cpId !== null) {
      queryParameters = queryParameters.set('cpId', <any>cpId);
    }
    if (policyNumber !== undefined && policyNumber !== null) {
      queryParameters = queryParameters.set('policyNumber', <any>policyNumber);
    }
    if (requestId !== undefined && requestId !== null) {
      queryParameters = queryParameters.set('requestId', <any>requestId);
    }
    if (serialNumber !== undefined && serialNumber !== null) {
      queryParameters = queryParameters.set('serialNumber', <any>serialNumber);
    }
    if (sign !== undefined && sign !== null) {
      queryParameters = queryParameters.set('sign', <any>sign);
    }
    if (url !== undefined && url !== null) {
      queryParameters = queryParameters.set('url', <any>url);
    }

    let headers = this.defaultHeaders;
    const httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected = this.configuration.selectHeaderAccept(
      httpHeaderAccepts
    );
    if (httpHeaderAcceptSelected !== undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    return this.httpClient.post<OtaResultOfPviInsurancePolicyDTO>(
      `${this.basePath}/api/inventory/pvi/process_order`,
      null,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers,
        observe,
        reportProgress
      }
    );
  }
}
